export default {
    PROPERTIES: "Свойства",
    ATTRIBUTES: "Атрибуты",
    MORE_THAN_ONE_OBJECT_SELECTED: "Выбрано более одного объекта",
    DELETE_TOOLTIP: "Удалить"
};
